export default function() {
    //placed until https://github.com/webpack-contrib/worker-loader/pull/98 is merged to master
    window.Worker = window.SharedWorker
}